<template>
  <div>
    <Leaf
      class="banner-design-elements"
      width="50px"
      style="right: 120px; top: 115px; opacity: 0.5"
      fill
    />
    <Circles
      class="banner-design-elements"
      width="300px"
      style="right: -5px; top: -10px; opacity: 0.4"
      stroke
    />
  </div>
</template>

<script setup>
import Circles from '@/components/design-elements/circles.vue'
import Leaf from '@/components/design-elements/leaf.vue'
</script>
